import { ChatWidget } from './components/chat/ChatWidget';

/**
 * Minimal blank host page for chatbot widget embed
 * No UI elements - just a clean mount point for the chat widget
 */
export default function App() {
  return (
    <div className="w-full h-full">
      {/* Only the chat widget renders - no other UI */}
      <ChatWidget />
    </div>
  );
}
